import classNames from "classnames";
import React from "react";

import { formatDate } from "@utils/date";
import { isDefined } from "@utils/helpers";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import "./promotionPeriod.scss";

type PromotionPeriodComponentProps = {
    validFrom: Date | undefined;
    validTo: Date;
    periodText?: string;
    className?: string;
};

const PromotionPeriodComponent = ({
    validFrom,
    validTo,
    periodText,
    className,
}: PromotionPeriodComponentProps) => {
    const { t } = useGranite();

    const formattedValidFrom = formatDate(validFrom, "dd-MM-yyyy");
    const formattedPeriod = formatDate(validTo, "dd-MM-yyyy");

    const translatedPeriod = isDefined(validFrom)
        ? t(
              "productDetail.promoLabel.promoPeriod",
              formattedValidFrom,
              formattedPeriod,
          )
        : t("productDetail.promoLabel.promoEnds", formattedPeriod);

    return (
        <p className={classNames("promotionPeriod", className)}>
            <span>{translatedPeriod}</span>
            {periodText && <span>({periodText})</span>}
        </p>
    );
};

export { PromotionPeriodComponent };
